module.exports = __webpack_public_path__ + "img/auto-out-null.svg";